import { MifosRepositoryFactory } from "@/repositories/mifos/MifosRepositoryFactory";
import { CreditEngineRepositoryFactory } from "@/repositories/creditengine/CreditEngineRepositoryFactory";
import { DataTables } from "@/utils/DataTables";
import dataTableUtils from "@/utils/DataTableUtils";
import EzUtils from "../utils/EzUtils";
import NetworkErrorUtil from "@/utils/NetworkErrorUtil";
import PaymentRepository from "../repositories/creditengine/PaymentRepository";
import PartnerRepository from "../repositories/creditengine/PartnerRepository";
import ProductRepository from "../repositories/creditengine/ProductRepository";
import SmsRepository from "../repositories/creditengine/SmsRepository";
import OTPRepository from "../repositories/creditengine/OTPRepository";
import ClientServiceRepository from "../repositories/mifos/ClientServiceRepository";
import OfficeServiceRepository from "../repositories/mifos/OfficeServiceRepository";
import AddressServiceRepository from "../repositories/mifos/AddressServiceRepository";
import CreditEngineOfficeServiceRepository
  from "../repositories/creditengine/CreditEngineOfficeServiceRepository";
import LoanStageRepository from "../repositories/creditengine/LoanStageRepository";
import ClientCreditEngineRepository
  from "../repositories/creditengine/ClientCreditEngineRepository";
import DataTablesRepository from "../repositories/mifos/DataTablesRepository";
import DocumentServiceRepository from "../repositories/mifos/DocumentServiceRepository";
import IpFinderRepository from "../repositories/ipaddress/IpFinderRepository";
import LeadRepository from "@/repositories/creditengine/LeadRepository";
import StaffServiceRepository
  from "@/repositories/mifos/StaffServiceRepository";
  import { Constants } from "../components/Constants";
import LoanServiceRepository from "../repositories/mifos/LoanServiceRepository";
import EzCredServiceRepository
  from "@/repositories/creditengine/EzCredServiceRepository";
import MasterDataRepository
  from "@/repositories/creditengine/MasterDataRepository";
//Credit Engine Repositories
const addressRepository = CreditEngineRepositoryFactory.get(CreditEngineRepositoryFactory.ADDRESS);
const emiSchemeRepository = CreditEngineRepositoryFactory.get(
  CreditEngineRepositoryFactory.EMI_SCHEMES);
const panRepository = CreditEngineRepositoryFactory.get(CreditEngineRepositoryFactory.PAN);
const loanCreditEngineRepository = CreditEngineRepositoryFactory.get(
  CreditEngineRepositoryFactory.LOAN);
const mandateRepository = CreditEngineRepositoryFactory.get(CreditEngineRepositoryFactory.MANDATE);
const signRepository = CreditEngineRepositoryFactory.get(CreditEngineRepositoryFactory.SIGN);
const perfiosRepository = CreditEngineRepositoryFactory.get(CreditEngineRepositoryFactory.PERFIOS);
const attributeCreditEngineRepository = CreditEngineRepositoryFactory.get(
  CreditEngineRepositoryFactory.ATTRIBUTE);
const documentRepository = CreditEngineRepositoryFactory.get(
  CreditEngineRepositoryFactory.DOCUMENT
);
const bankRepository = CreditEngineRepositoryFactory.get(CreditEngineRepositoryFactory.BANK);
const mailRepository = CreditEngineRepositoryFactory.get(CreditEngineRepositoryFactory.MAIL);
const webViewRepository = CreditEngineRepositoryFactory.get(CreditEngineRepositoryFactory.WEBVIEW);
const lenderRepository = CreditEngineRepositoryFactory.get(CreditEngineRepositoryFactory.LENDER);

//Mifos Repositories
const codeValueRepository = MifosRepositoryFactory.get(MifosRepositoryFactory.CODE_SERVICE);
const loanServiceRepository = MifosRepositoryFactory.get(MifosRepositoryFactory.LOAN_SERVICE);
const searchServiceRepository = MifosRepositoryFactory.get(MifosRepositoryFactory.SEARCH_SERVICE);
import vendorKycRepository
  from "../repositories/creditengine/VendorKycRepository";
import HooksRepository from "@/repositories/creditengine/HooksRepository";
import DataTableCreditEngineRepository
  from "@/repositories/creditengine/DataTableCreditEngineRepository";
import UserRepository from "../repositories/mifos/UserRepository";
import LoanCreditEngineRepository
  from "@/repositories/creditengine/LoanCreditEngineRepository";
import CamsApi from "@/repositories/camsspay/CamsApi";

export default {

  getEzLoanById(loanId, fetchDisplayElements, fetchAssociatedEntities) {
    return new Promise(resolve => {
      loanServiceRepository.getLoanById(loanId)
        .then(loans => {
          DataTablesRepository.getDataTableInfo(DataTables.LOAN_DETAILS, loans.data.id)
            .then(loanDetails => {
                DataTablesRepository.getDataTableInfo(DataTables.LENDER_LOAN_DETAILS, loans.data.id)
                  .then(lenderLoanDetails => {
                    let lenderLoanDetail = this.getLenderLoanDetailsdFormLenderLoanDetailsResponse(lenderLoanDetails);
                    if (fetchDisplayElements) {
                      LoanCreditEngineRepository.getLoanDisplayElements(loanId)
                      .then(displayElementsRes => {

                        if (fetchAssociatedEntities) {
                          DataTablesRepository.getDataTableInfo(DataTables.ASSOCIATED_ENTITIES, loanId)
                          .then(associatedEntitiesRes => {
                            resolve(this.onResponse({
                              "loan": loans.data,
                              "loanDetails": loanDetails.data[0],
                              lenderLoanDetail: lenderLoanDetail,
                              displayElements: displayElementsRes.data,
                              associatedEntities: associatedEntitiesRes.data
                            }));
                          })
                          .catch(error => {
                            resolve(this.onError(
                                NetworkErrorUtil.getNetworkIssueDetails(error)
                            ));
                          })
                        } else {
                          resolve(this.onResponse({
                            "loan": loans.data,
                            "loanDetails": loanDetails.data[0],
                            lenderLoanDetail: lenderLoanDetail,
                            displayElements: displayElementsRes.data
                          }));
                        }
                      })
                      .catch(error => {
                        resolve(this.onError(
                            NetworkErrorUtil.getNetworkIssueDetails(error)
                        ));
                      })
                    } else {
                      if (fetchAssociatedEntities) {
                        DataTablesRepository.getDataTableInfo(DataTables.ASSOCIATED_ENTITIES, loanId)
                        .then(associatedEntitiesRes => {
                          resolve(this.onResponse({
                            "loan": loans.data,
                            "loanDetails": loanDetails.data[0],
                            lenderLoanDetail: lenderLoanDetail,
                            associatedEntities: associatedEntitiesRes.data
                          }));
                        })
                        .catch(error => {
                          resolve(this.onError(
                              NetworkErrorUtil.getNetworkIssueDetails(error)
                          ));
                        })
                      } else {
                        resolve(this.onResponse({
                          "loan": loans.data,
                          "loanDetails": loanDetails.data[0],
                          lenderLoanDetail: lenderLoanDetail
                        }));
                      }
                    }
                  })
                  .catch(error => {
                    resolve(this.onError(NetworkErrorUtil.getNetworkIssueDetails(error)));
                  });
            })
            .catch(error => {
              resolve(this.onError(NetworkErrorUtil.getNetworkIssueDetails(error)));
            });
        })
        .catch(error => {
          resolve(this.onError(NetworkErrorUtil.getNetworkIssueDetails(error)));
        })
    });
  },

  getLoanByResources(query, resourceName, exactMatch) {
    let returnResponse = [];
    return new Promise(resolve => {
      searchServiceRepository.searchResources(query, resourceName, exactMatch)
        .then(response => {
          let searchedEntities = response['data'];
          if (searchedEntities && searchedEntities.length > 0) {
            for (let searchedEntitiesIndex = 0; searchedEntitiesIndex < searchedEntities.length; searchedEntitiesIndex++) {
              let searchedEntity = searchedEntities[searchedEntitiesIndex];
              let isSearchedEntityLast = searchedEntitiesIndex == (searchedEntities.length - 1) ? true : false;
              const entityId = searchedEntity['entityId'];
              const entityType = searchedEntity['entityType'];

              //Form client table
              if(entityType===Constants.ENTITY_CLIENT){
                ClientServiceRepository.getClientAccounts(entityId)
                .then(clientAccountsResponse => {
                  if(clientAccountsResponse['data']['loanAccounts']!=undefined){
                    const loanAccounts = clientAccountsResponse['data']['loanAccounts'];
                    if (loanAccounts != null && loanAccounts.length > 0) {
                      for (let loanAccountsIndex = 0; loanAccountsIndex < loanAccounts.length; loanAccountsIndex++) {
                        const loanAccount = loanAccounts[loanAccountsIndex];
                        let isloanAccountLast = loanAccountsIndex == (loanAccounts.length - 1) ? true : false;
                        const loanId = loanAccount['id'];
                        this.getEzLoanById(loanId)
                          .then(ezLoanResponse => {
                            const errorOccurred = ezLoanResponse['errorOccurred'];
                            if (!errorOccurred) {
                              const ezLoan = ezLoanResponse['data'];
                              returnResponse.push(ezLoan);
                              if (isloanAccountLast && isSearchedEntityLast){
                                resolve(this.onResponse(returnResponse));
                              }

                            }
                          }).catch(error => {
                            resolve(this.onError(NetworkErrorUtil.getNetworkIssueDetails(error)));
                          });
                      };
                    }
                  }else{
                    console.warn(`Loan account not found for entity id ${entityId}`);
                    if (isSearchedEntityLast){
                      resolve(this.onResponse(returnResponse));
                    }
                  }
                }).catch(error => {
                  resolve(this.onResponse(returnResponse));
                });
              }

              //form loan table
              else if(entityType===Constants.ENTITY_LOAN){
                this.getEzLoanById(entityId)
                  .then(ezLoanResponse => {
                    const errorOccurred = ezLoanResponse['errorOccurred'];
                    if (!errorOccurred) {
                      const ezLoan = ezLoanResponse['data'];
                      returnResponse.push(ezLoan);
                      if (isSearchedEntityLast)
                        resolve(this.onResponse(returnResponse));
                    }
                  }).catch(error => {
                    resolve(this.onError(NetworkErrorUtil.getNetworkIssueDetails(error)));
                  });
              }

            };
          }else{
            resolve(this.onResponse(returnResponse));
          }
        })
        .catch(error => {
          resolve(this.onError(NetworkErrorUtil.getNetworkIssueDetails(error)));
        })
    });
  },

  getLoansForStages(offset, limit, accountNo, externalId, orderBy, sortOrder, staffId, officeId, loanApplicationType) {
    let sqlQuery = "";
    if (EzUtils.isValidId(officeId)) {
      sqlQuery = "l.office_id=" + officeId;
    }
    if (EzUtils.isValidId(staffId)) {
      if (EzUtils.isNotEmpty(sqlQuery)) {
        sqlQuery += " and "
      }
      sqlQuery += "l.loan_officer_id = " + staffId;
    }

    if (EzUtils.isValidString(loanApplicationType)) {
      if (EzUtils.isNotEmpty(sqlQuery)) {
        sqlQuery += " and "
      }
      sqlQuery += "l.loan_application_type='" + loanApplicationType +"'";
    }


    return new Promise(resolve => {
      loanServiceRepository.getAllLoans(
        offset, limit, accountNo,
        externalId, orderBy, sortOrder,
        sqlQuery, null, null
      )
        .then(res => {
          let returnResponse = [];
          if (res.data && res.data.pageItems && res.data.pageItems.length > 0) {
            const noOfLoans = res.data.pageItems.length;
            let pageItemIndex = 0;
            while (pageItemIndex++ < noOfLoans) {
              returnResponse.push({})
            }
            let addedLoans = 0;
            res.data.pageItems.forEach((pageItem, pageItemIndex) => {
              DataTablesRepository.getDataTableInfo(DataTables.LOAN_DETAILS, pageItem.id)
                .then(loanDetails => {
                  DataTablesRepository.getDataTableInfo(DataTables.LENDER_LOAN_DETAILS, loanDetails.data[0].loan_id)
                    .then(lenderLoanDetails => {
                      let lenderLoanDetail = this.getLenderLoanDetailsdFormLenderLoanDetailsResponse(lenderLoanDetails);
                      returnResponse.splice(
                        pageItemIndex,
                        1,
                        { loan: pageItem, loanDetails: loanDetails.data[0], lenderLoanDetail: lenderLoanDetail }
                      );
                      addedLoans++;
                      if (addedLoans === noOfLoans) {
                        resolve(this.onResponse(returnResponse));
                      }
                    })
                    .catch(error => {
                      resolve(this.onError(NetworkErrorUtil.getNetworkIssueDetails(error)));
                    });
                })
                .catch(error => {
                  resolve(this.onError(NetworkErrorUtil.getNetworkIssueDetails(error)));
                });
            })
          } else {
            resolve(this.onResponse(returnResponse));
          }
        })
        .catch(error => {
          resolve(this.onError(NetworkErrorUtil.getNetworkIssueDetails(error)));
        })
    })
  },

  getDataTableByDataTableName(tableName) {
    //TODO save in cache and fetch if already exists(same as android app) @anish
    return new Promise(resolve => {
      DataTablesRepository.getTableByDataTableName(tableName)
        .then(dataTableRes => {
          resolve(this.onResponse(EzUtils.convertToJSONObjectIfString(dataTableRes.data)));
        })
        .catch(error => {
          resolve(this.onError(NetworkErrorUtil.getNetworkIssueDetails(error)));
        })
    })
  },

  // return array
  getDataTableInfo(tableName, entityId) {
    return new Promise(resolve => {
      this.getDataTableByDataTableName(tableName)
        .then(dataTableRes => {
          if (dataTableRes.errorOccurred) {
            resolve(this.onError(dataTableRes.data))
          } else {
            let dataTable = dataTableRes.data;
            DataTablesRepository.getDataTableInfo(tableName, entityId)
              .then(dataTableInfoRes => {
                if (EzUtils.isEmpty(dataTableInfoRes.data)) {
                  resolve(this.onResponse([]))
                } else {
                  let tableEntitiesArray = [];
                  let jsonArray = EzUtils.convertToJSONObjectIfString(dataTableInfoRes.data);
                  jsonArray.forEach((dataElement, index, data) => {
                    tableEntitiesArray.push(
                      dataTableUtils.mapJsonArrayElements(dataElement, dataTable));
                  });
                  resolve(this.onResponse(tableEntitiesArray))
                }
              })
              .catch(error => {
                resolve(this.onError(NetworkErrorUtil.getNetworkIssueDetails(error)));
              })
          }
        });
    })
  },

  // return array
  getDataOfDataTableInfoWithFilter(tableName, entityId, columnName, columnValue) {
    return new Promise(resolve => {
      this.getDataTableByDataTableName(tableName)
        .then(dataTableRes => {
          if (dataTableRes.errorOccurred) {
            resolve(this.onError(dataTableRes.data))
          } else {
            let dataTable = dataTableRes.data;
            DataTablesRepository.getDataOfDataTableInfoWithFilter(
              tableName,
              entityId,
              columnName,
              columnValue
            )
              .then(dataTableInfoRes => {
                if (EzUtils.isEmpty(dataTableInfoRes.data)) {
                  resolve(this.onResponse([]))
                } else {
                  let tableEntitiesArray = [];
                  let jsonArray = EzUtils.convertToJSONObjectIfString(dataTableInfoRes.data);
                  jsonArray.forEach((dataElement, index, data) => {
                    tableEntitiesArray.push(
                      dataTableUtils.mapJsonArrayElements(dataElement, dataTable));
                  });
                  resolve(this.onResponse(tableEntitiesArray))
                }
              })
              .catch(error => {
                resolve(this.onError(NetworkErrorUtil.getNetworkIssueDetails(error)));
              })
          }
        });
    })
  },

  // return array
  addDataTableEntry(tableName, entityId, payload) {
    return new Promise(resolve => {
      this.getDataTableByDataTableName(tableName)
        .then(dataTableRes => {
          if (dataTableRes.errorOccurred) {
            resolve(this.onError(dataTableRes.data))
          } else {
            let dataTable = dataTableRes.data;
            DataTablesRepository.addDataTableEntry(tableName, entityId,
              dataTableUtils.mapDataTablePayload(payload, dataTable))
              .then(dataTableInfoRes => {
                resolve(this.onResponse(dataTableInfoRes.data))
              })
              .catch(error => {
                resolve(this.onError(NetworkErrorUtil.getNetworkIssueDetails(error)));
              })
          }
        });
    })
  },

  updateDataTableEntryInMultiRowDataTable(tableName, entityId, rowId, payload) {
    // Todo need to fetch getTableByDataTableName from server and pass in mapDataTablePayload
    return new Promise(resolve => {
      this.getDataTableByDataTableName(tableName)
        .then(dataTableRes => {
          if (dataTableRes.errorOccurred) {
            resolve(this.onError(dataTableRes.data))
          } else {
            let dataTable = dataTableRes.data;
            DataTablesRepository.updateDataTableEntryInMultiRowDataTable(tableName, entityId, rowId,
              dataTableUtils.mapDataTablePayload(payload, dataTable))
              .then(dataTableInfoRes => {
                resolve(this.onResponse(dataTableInfoRes.data))
              })
              .catch(error => {
                resolve(this.onError(NetworkErrorUtil.getNetworkIssueDetails(error)));
              })
          }
        });
    })
  },

  updateDataTableEntry(tableName, entityId, payload) {
    return new Promise(resolve => {
      this.getDataTableByDataTableName(tableName)
        .then(dataTableRes => {
          if (dataTableRes.errorOccurred) {
            resolve(this.onError(dataTableRes.data))
          } else {
            let dataTable = dataTableRes.data;
            DataTablesRepository.updateDataTableEntry(tableName, entityId,
              dataTableUtils.mapDataTablePayload(payload, dataTable))
              .then(dataTableInfoRes => {
                resolve(this.onResponse(dataTableInfoRes.data))
              })
              .catch(error => {
                resolve(this.onError(NetworkErrorUtil.getNetworkIssueDetails(error)));
              })
          }
        });
    })
  },

  getLoanStageConfigData(loanId, loanStageName, role) {
    return new Promise(resolve => {
      LoanStageRepository.getLoanStageConfigData(loanId, loanStageName, role)
        .then(res => {
          resolve(this.onResponse(res.data))
        })
        .catch(error => {
          resolve(this.onError(NetworkErrorUtil.getNetworkIssueDetails(error)));
        })
    })
  },

  getCodes() {
    return new Promise(resolve => {
      codeValueRepository.getCodes().then(res => {
        resolve(this.onResponse(res.data))
      })
        .catch(error => {
          resolve(this.onError(NetworkErrorUtil.getNetworkIssueDetails(error)));
        })
    })
  },

  getCodesValues(codeId) {
    return new Promise(resolve => {
      codeValueRepository.getCodeValues(codeId).then(res => {
        resolve(this.onResponse(res.data))
      })
        .catch(error => {
          resolve(this.onError(NetworkErrorUtil.getNetworkIssueDetails(error)));
        })
    })
  },

  getEmiSchemes(
    clientId, profession, category,
    brand, model, price,
    officeId, partnerName, loanId
  ) {
    return new Promise(resolve => {
      emiSchemeRepository.getEmiSchemes(
        clientId, profession, category,
        brand, model, price,
        officeId, partnerName, loanId
      )
        .then(res => {
          let emiSchemes = [];
          if (res.data && res.data.data && res.data.data.length > 0) {
            const noOfEmiSchemes = res.data.data.length;
            let emiSchemeIndex = 0;
            while (emiSchemeIndex++ < noOfEmiSchemes) {
              emiSchemes.push({});
            }

            let addedEmiSchemes = 0;
            res.data.data.forEach((emiScheme, emiSchemeIndex) => {
              if (EzUtils.isValidId(emiScheme.mifosLoanProductId)) {
                this.getLoanProductById(emiScheme.mifosLoanProductId)
                  .then(loanProductRes => {
                    if (loanProductRes.errorOccurred) {
                      resolve(this.onError(loanProductRes.data))
                    } else {
                      emiScheme.loanProduct = loanProductRes.data;
                      emiSchemes.splice(emiSchemeIndex, 1, emiScheme)
                      addedEmiSchemes++;
                      if (addedEmiSchemes === noOfEmiSchemes) {
                        resolve(this.onResponse(emiSchemes));
                      }
                    }
                  })
              } else {
                emiScheme.loanProduct = null;
                emiSchemes.splice(emiSchemeIndex, 1, emiScheme)
                addedEmiSchemes++;
                if (addedEmiSchemes === noOfEmiSchemes) {
                  resolve(this.onResponse(emiSchemes))
                }
              }
            })
          } else {
            resolve(this.onResponse(emiSchemes))
          }
        })
        .catch(error => {
          resolve(this.onError(NetworkErrorUtil.getNetworkIssueDetails(error)));
        })
    })
  },

  saveEMiScheme(emiScheme) {
    return new Promise(resolve => {
      emiSchemeRepository.saveEmiScheme(emiScheme)
        .then(res => {
          resolve(this.onResponse(res.data))
        })
        .catch(error => {
          resolve(this.onError(NetworkErrorUtil.getNetworkIssueDetails(error)));
        })
    })
  },

  getLoanProductById(loanProductId) {
    return new Promise(resolve => {
      loanServiceRepository.getLoanProductById(loanProductId)
        .then(res => {
          resolve(this.onResponse(res.data))
        })
        .catch(error => {
          resolve(this.onError(NetworkErrorUtil.getNetworkIssueDetails(error)));
        })
    })
  },

  updateLoansAccount(loanId, loansPayload) {
    return new Promise(resolve => {
      loanServiceRepository.updateLoansAccount(loanId, loansPayload)
        .then(res => {
          resolve(this.onResponse(res.data))
        })
        .catch(error => {
          resolve(this.onError(NetworkErrorUtil.getNetworkIssueDetails(error)));
        })
    })
  },

  getConsentDetails(officeId, role, officeExternalId) {
    return new Promise(resolve => {
      LoanStageRepository.getConsentDetails(officeId, role, officeExternalId)
        .then(res => {
          resolve(this.onResponse(res.data))
        })
        .catch(error => {
          resolve(this.onError(NetworkErrorUtil.getNetworkIssueDetails(error)));
        });
    })
  },

  getLeadDetails(leadId, mobileNumber, retailerName, partnerReferenceId, officeId) {
    return new Promise(resolve => {
      LeadRepository.getLeadDetails(leadId, mobileNumber, retailerName, partnerReferenceId, officeId)
        .then(res => {
          resolve(this.onResponse(res.data))
        })
        .catch(error => {
          resolve(this.onError(NetworkErrorUtil.getNetworkIssueDetails(error)));
        });
    })
  },

  getLeadDetailsWithAccessCheck(leadId, mobileNumber) {
    return new Promise(resolve => {
      LeadRepository.getLeadDetailsWithAccessCheck(leadId, mobileNumber)
        .then(res => {
          resolve(this.onResponse(res.data))
        })
        .catch(error => {
          resolve(this.onError(NetworkErrorUtil.getNetworkIssueDetails(error)));
        });
    })
  },

  isSecondaryMobileRequired(leadId, mobileNumber) {
    return new Promise(resolve => {
      LeadRepository.isSecondaryMobileRequired(leadId, mobileNumber)
        .then(res => {
          resolve(this.onResponse(res.data))
        })
        .catch(error => {
          resolve(this.onError(NetworkErrorUtil.getNetworkIssueDetails(error)));
        });
    })
  },

  sendLeadLinkOnSecondaryMobile(leadId) {
    return new Promise(resolve => {
      LeadRepository.sendLeadLinkOnSecondaryMobile(leadId)
        .then(res => {
          resolve(this.onResponse(res.data))
        })
        .catch(error => {
          resolve(this.onError(NetworkErrorUtil.getNetworkIssueDetails(error)));
        });
    })
  },

  verifyClientIdentifiers(clientIdentifierCheckRequest) {
    return new Promise(resolve => {
      ClientCreditEngineRepository.verifyClientIdentifiers(clientIdentifierCheckRequest)
        .then(res => {
          resolve(this.onResponse(res.data))
        })
        .catch(error => {
          resolve(this.onError(NetworkErrorUtil.getNetworkIssueDetails(error)));
        });
    })
  },

  updateClientMobileNumber(updateClientMobileNumberRequest) {
    return new Promise(resolve => {
      ClientCreditEngineRepository.updateClientMobileNumber(updateClientMobileNumberRequest)
      .then(res => {
        resolve(this.onResponse(res.data))
      })
      .catch(error => {
        resolve(this.onError(NetworkErrorUtil.getNetworkIssueDetails(error)));
      });
    })
  },

  saveClientAccounts(loanId, clientsAccountRequest) {
    return new Promise(resolve => {
      ClientCreditEngineRepository.saveClientAccounts(loanId, clientsAccountRequest)
        .then(res => {
          resolve(this.onResponse(res.data));
        })
        .catch(error => {
          resolve(this.onError(NetworkErrorUtil.getNetworkIssueDetails(error)));
        })
    })
  },

  verifyPan(panVerificationRequest) {
    return new Promise(resolve => {
      panRepository.verifyPan(panVerificationRequest)
        .then(res => {
          resolve(this.onResponse(res.data))
        })
        .catch(error => {
          resolve(this.onError(NetworkErrorUtil.getNetworkIssueDetails(error)));
        });
    })
  },

  createLoanOnCreditEngine(loanCreationPayload) {
    return new Promise(resolve => {
      loanCreditEngineRepository.createLoan(loanCreationPayload)
        .then(res => {
          resolve(this.onResponse(res.data))
        })
        .catch(error => {
          resolve(this.onError(NetworkErrorUtil.getNetworkIssueDetails(error)));
        });
    })
  },

  getAddressTemplates() {
    return new Promise(resolve => {
      ClientServiceRepository.getAddressTemplates()
        .then(res => {
          resolve(this.onResponse(res.data))
        })
        .catch(error => {
          resolve(this.onError(NetworkErrorUtil.getNetworkIssueDetails(error)));
        });
    })
  },

  getClientAddress(clientId, status, addressType) {
    return new Promise(resolve => {
      ClientServiceRepository.getClientAddress(clientId, status, addressType)
        .then(res => {
          resolve(this.onResponse(res.data))
        })
        .catch(error => {
          resolve(this.onError(NetworkErrorUtil.getNetworkIssueDetails(error)));
        });
    })
  },

  camspayInstanach(request) {
    return new Promise(resolve => {
      CamsApi.instaNach(request)
      .then(res => {
        console.log("res")
        console.log(res.data)
        resolve(this.onResponse(res.data))
      })
      .catch(error => {
        console.log("error")
        console.log(error)
        resolve(this.onError(NetworkErrorUtil.getNetworkIssueDetails(error)));
      });
    })
  },

  updateClientAddress(clientId, addressTypeId, address) {
    return new Promise(resolve => {
      ClientServiceRepository.updateClientAddress(clientId, addressTypeId, address)
        .then(res => {
          resolve(this.onResponse(res.data))
        })
        .catch(error => {
          resolve(this.onError(NetworkErrorUtil.getNetworkIssueDetails(error)));
        });
    })
  },

  saveClientAddress(clientId, addressTypeId, address) {
    return new Promise(resolve => {
      ClientServiceRepository.saveClientAddress(clientId, addressTypeId, address)
        .then(res => {
          resolve(this.onResponse(res.data))
        })
        .catch(error => {
          resolve(this.onError(NetworkErrorUtil.getNetworkIssueDetails(error)));
        });
    })
  },

  updateLoanStage(loanId, loanStageId, loanStage, loanStatus) {
    return new Promise(resolve => {
      loanCreditEngineRepository.updateLoanStage(loanId, loanStageId, loanStage, loanStatus)
        .then(res => {
          resolve(this.onResponse(res.data))
        })
        .catch(error => {
          resolve(this.onError(NetworkErrorUtil.getNetworkIssueDetails(error)));
        });
    })
  },

  getPincodeDetails(pincode) {
    return new Promise(resolve => {
      addressRepository.getPincodeDetails(pincode)
        .then(res => {
          resolve(this.onResponse(res.data))
        })
        .catch(error => {
          resolve(this.onError(NetworkErrorUtil.getNetworkIssueDetails(error)));
        })
    })
  },

  createDocument(entityType, entityId, name, description, subDirectory, file, checkForFileType) {
    return new Promise(resolve => {
      const checkForFileFormat = typeof checkForFileType === "boolean"
          ? checkForFileType : true;
      if (!checkForFileFormat || EzUtils.isFileAllowedToUpload(file)) {
        DocumentServiceRepository.createDocument(entityType, entityId, name, description,
          subDirectory, file)
          .then(res => {
            resolve(this.onResponse(res.data))
          })
          .catch(error => {
            resolve(this.onError(NetworkErrorUtil.getNetworkIssueDetails(error)));
          })
      } else {
        resolve(this.onError(NetworkErrorUtil.getErrorObject("Invalid File",
          "File format not supported, Please upload image or pdf")))
      }
    })
  },

  updateDocument(
    entityType,
    entityId,
    documentId,
    comments,
    name,
    description,
    verificationStatus,
    file
  ) {
    return new Promise(resolve => {
      if (!file || EzUtils.isFileAllowedToUpload(file)) {
        DocumentServiceRepository.updateDocument(
          entityType, entityId, documentId,
          comments, name, description,
          verificationStatus, file
        ).then(res => {
          resolve(this.onResponse(res.data))
        }).catch(error => {
          resolve(this.onError(NetworkErrorUtil.getNetworkIssueDetails(error)))
        })
      } else {
        resolve(this.onError(NetworkErrorUtil.getErrorObject("Invalid File",
          "File format not supported, Please upload image or pdf")))
      }
    })
  },

  removeDocument(entityType, entityId, documentId) {
    return new Promise(resolve => {
      DocumentServiceRepository.removeDocument(entityType, entityId, documentId)
        .then(res => {
          resolve(this.onResponse(res.data))
        })
        .catch(error => {
          resolve(this.onError(NetworkErrorUtil.getNetworkIssueDetails(error)));
        })
    })
  },

  uploadClientImage(clientId, subDirectory, file) {
    return new Promise(resolve => {
      if (EzUtils.isFileImage(file)) {
        ClientServiceRepository.uploadClientImage(clientId, subDirectory, file)
          .then(res => {
            resolve(this.onResponse(res.data))
          })
          .catch(error => {
            resolve(this.onError(NetworkErrorUtil.getNetworkIssueDetails(error)));
          })
      } else {
        resolve(this.onError(NetworkErrorUtil.getErrorObject("Invalid File",
          "File format not supported, Please upload image.")))
      }
    })
  },

  createOrUpdateAttribute(attributeData) {
    return new Promise(resolve => {
      attributeCreditEngineRepository.createOrUpdateAttribute(attributeData)
        .then(res => {
          resolve(this.onResponse(res.data))
        })
        .catch(error => {
          resolve(this.onError(NetworkErrorUtil.getNetworkIssueDetails(error)));
        })
    })
  },

  getAttributes(entityType, entityId) {
    return new Promise(resolve => {
      attributeCreditEngineRepository.getAttributes(entityType, entityId)
        .then(res => {
          resolve(this.onResponse(res.data));
        })
        .catch(error => {
          resolve(this.onError(NetworkErrorUtil.getNetworkIssueDetails(error)));
        })
    })
  },

  getMandateConfiguration(mandateConfigRequest) {
    return new Promise(resolve => {
      mandateRepository.getMandateConfiguration(mandateConfigRequest)
        .then(res => {
          resolve(this.onResponse(res.data))
        })
        .catch(error => {
          resolve(this.onError(NetworkErrorUtil.getNetworkIssueDetails(error)));
        })
    })
  },

  getEsignConfiguration(esignConfigRequest) {
    return new Promise(resolve => {
      signRepository.getEsignConfiguration(esignConfigRequest)
        .then(res => {
          resolve(this.onResponse(res.data))
        })
        .catch(error => {
          resolve(this.onError(NetworkErrorUtil.getNetworkIssueDetails(error)));
        })
    })
  },

  saveSignMode(signModeRequest) {
    return new Promise(resolve => {
      signRepository.saveSignMode(signModeRequest)
        .then(res => {
          resolve(this.onResponse(res.data))
        })
        .catch(error => {
          resolve(this.onError(NetworkErrorUtil.getNetworkIssueDetails(error)));
        })
    })
  },

  triggerDocument(loanId, clientId, documentName) {
    return new Promise(resolve => {
      signRepository.triggerDocument(loanId, clientId, documentName)
        .then(res => {
          resolve(this.onResponse(res.data))
        })
        .catch(error => {
          resolve(this.onError(NetworkErrorUtil.getNetworkIssueDetails(error)));
        })
    })
  },

  createClient(clientPayload) {
    return new Promise(resolve => {
      ClientServiceRepository.createClient(clientPayload)
        .then(res => {
          resolve(this.onResponse(res.data));
        })
        .catch(error => {
          resolve(this.onError(NetworkErrorUtil.getNetworkIssueDetails(error)));
        })
    })
  },

  updateClient(clientId, clientPayload) {
    return new Promise(resolve => {
      ClientServiceRepository.updateClient(clientId, clientPayload)
        .then(res => {
          resolve(this.onResponse(res.data));
        })
        .catch(error => {
          resolve(this.onError(NetworkErrorUtil.getNetworkIssueDetails(error)));
        })
    })
  },

  getClient(clientId) {
    return new Promise(resolve => {
      ClientServiceRepository.getClient(clientId)
        .then(res => {
          resolve(this.onResponse(res.data));
        })
        .catch(error => {
          resolve(this.onError(NetworkErrorUtil.getNetworkIssueDetails(error)));
        })
    })
  },

  getClientIdentifierTemplate(clientId) {
    return new Promise(resolve => {
      ClientServiceRepository.getClientIdentifierTemplate(clientId)
        .then(res => {
          resolve(this.onResponse(res.data))
        })
        .catch(error => {
          resolve(this.onError(NetworkErrorUtil.getNetworkIssueDetails(error)))
        })
    })
  },

  getClientTemplate() {
    return new Promise(resolve => {
      ClientServiceRepository.getClientTemplate()
        .then(res => {
          resolve(this.onResponse(res.data))
        })
        .catch(error => {
          resolve(this.onError(NetworkErrorUtil.getNetworkIssueDetails(error)))
        })
    })
  },

  getClientIdentifiers(clientId) {
    return new Promise(resolve => {
      ClientServiceRepository.getClientIdentifiers(clientId)
        .then(res => {
          resolve(this.onResponse(res.data))
        })
        .catch(error => {
          resolve(this.onError(NetworkErrorUtil.getNetworkIssueDetails(error)))
        })
    })
  },

  getDocuments(entityType, entityId) {
    return new Promise(resolve => {
      DocumentServiceRepository.getDocuments(entityType, entityId)
        .then(res => {
          resolve(this.onResponse(res.data))
        })
        .catch(error => {
          resolve(this.onError(NetworkErrorUtil.getNetworkIssueDetails(error)))
        })
    })
  },

  getClientImage(clientId, documentId) {
    return new Promise(resolve => {
      ClientServiceRepository.getClientImage(clientId, documentId)
        .then(res => {
          resolve(this.onResponse(res.data))
        })
        .catch(error => {
          resolve(this.onError(NetworkErrorUtil.getNetworkIssueDetails(error)))
        })
    })
  },

  createDocumentLocation(entityType, entityId, name, description, fileName, fileLocation) {
    return new Promise(resolve => {
      DocumentServiceRepository.createDocumentLocation(entityType, entityId, name, description,
        fileName, fileLocation)
        .then(res => {
          resolve(this.onResponse(res.data))
        })
        .catch(error => {
          resolve(this.onError(NetworkErrorUtil.getNetworkIssueDetails(error)))
        })
    })
  },

  uploadDocument(
    entityType, entityId, name,
    description, subDirectory, file,
    imageType, uploadToMifos
  ) {
    return new Promise(resolve => {
      documentRepository.uploadDocument(
        entityType, entityId, name,
        description, subDirectory, file,
        imageType, uploadToMifos
      ).then(res => {
        resolve(this.onResponse(res.data))
      })
        .catch(error => {
          resolve(this.onError(NetworkErrorUtil.getNetworkIssueDetails(error)))
        })
    })
  },

  createClientIdentifierUsingMifos(clientId, documentType, documentId) {
    return new Promise(resolve => {
      return this.getClientIdentifierTemplate(0)
        .then(identifierTemplateData => {
          let identifierPayload = this.getIdentifierPayload(
            documentType.documentType,
            documentId,
            documentType.description,
            "active",
            identifierTemplateData.data
          );
          ClientServiceRepository.createClientIdentifier(clientId, identifierPayload).then(res => {
            resolve(this.onResponse(res.data))
          }).catch(error => {
            resolve(this.onError(NetworkErrorUtil.getNetworkIssueDetails(error)))
          })
        })
    })
  },

  checkPdfPassword(pdfPasswordRequest) {
    return new Promise(resolve => {
      documentRepository.checkPdfPassword(pdfPasswordRequest)
        .then(res => {
          resolve(this.onResponse(res.data))
        })
        .catch(error => {
          resolve(this.onError(NetworkErrorUtil.getNetworkIssueDetails(error)))
        })
    })
  },

  getBankIFSCDetails(ifscCode) {
    return new Promise(resolve => {
      bankRepository.getBankIFSCDetails(ifscCode)
        .then(res => {
          resolve(this.onResponse(res.data))
        })
        .catch(error => {
          resolve(this.onError(NetworkErrorUtil.getNetworkIssueDetails(error)))
        })
    })
  },

  getLenderWebView(secretKey) {
    return new Promise(resolve => {
      webViewRepository.getLenderWebView(secretKey)
        .then(res => {
          resolve(this.onResponse(res.data))
        })
        .catch(error => {
          resolve(this.onError(NetworkErrorUtil.getNetworkIssueDetails(error)))
        })
    })
  },

  getLoanAccountDetailsByAccountNumber(accountNumber) {
    return new Promise(resolve => {
      loanServiceRepository.getLoanAccountDetailsByAccountNumber(accountNumber)
        .then(res => {
          resolve(this.onResponse(res.data))
        })
        .catch(error => {
          resolve(this.onError(NetworkErrorUtil.getNetworkIssueDetails(error)))
        })
    })
  },

  getEsignSuccessView(loanId) {
    return new Promise(resolve => {
      signRepository.getEsignSuccessView(loanId)
        .then(res => {
          resolve(this.onResponse(res.data))
        }).catch(error => {
          resolve(this.onError(NetworkErrorUtil.getNetworkIssueDetails(error)))
        })
    })
  },

  getLenderOtpView(secretKey) {
    return new Promise(resolve => {
      webViewRepository.getLenderOtpView(secretKey)
        .then(res => {
          resolve(this.onResponse(res.data))
        })
        .catch(error => {
          resolve(this.onError(NetworkErrorUtil.getNetworkIssueDetails(error)))
        })
    })
  },

  verifyLenderOtp(secretKey, otp) {
    return new Promise(resolve => {
      webViewRepository.verifyOtp(secretKey, otp)
        .then(res => {
          resolve(this.onResponse(res.data))
        })
        .catch(error => {
          resolve(this.onError(error.response.data))
        })
    })
  },

  verifyLenderOtpAndGetResponse(secretKey, otp) {
    return new Promise(resolve => {
      webViewRepository.verifyOtpAndGetResponse(secretKey, otp)
        .then(res => {
          resolve(this.onResponse(res.data))
        })
        .catch(error => {
          resolve(this.onError(NetworkErrorUtil.getNetworkIssueDetails(error)))
        })
    })
  },

  resendLenderOtp(secretKey) {
    return new Promise(resolve => {
      webViewRepository.resendOtp(secretKey)
        .then(res => {
          resolve(this.onResponse(res.data))
        })
        .catch(error => {
          resolve(this.onError(NetworkErrorUtil.getNetworkIssueDetails(error)))
        })
    })
  },

  getIdentifierPayload(
    documentType, documentKey, description,
    status, identifierTemplate
  ) {
    let identifierPayload = {};
    identifierPayload["documentTypeId"] = dataTableUtils.getDocumentTypeId(
      identifierTemplate.allowedDocumentTypes, documentType);

    identifierPayload["documentKey"] = documentKey;
    identifierPayload["description"] = description;
    identifierPayload["status"] = status;

    return identifierPayload;
  },

  /***
   *
   * @param sendMailRequest<array<String> to, String from, String subject, String body>
   * @returns {Promise<any>} response or error
   */
  sendMail(sendMailRequest) {
    return new Promise(resolve => {
      mailRepository.sendMail(sendMailRequest)
        .then(res => {
          resolve(this.onResponse(res.data))
        })
        .catch(error => {
          resolve(this.onError(NetworkErrorUtil.getNetworkIssueDetails(error)))
        })
    })
  },

  initiatePerfios(perfiosInitiateRequest) {
    return new Promise(resolve => {
      perfiosRepository.initiatePerfios(perfiosInitiateRequest)
        .then(res => {
          resolve(this.onResponse(res.data))
        })
        .catch(error => {
          resolve(this.onError(NetworkErrorUtil.getNetworkIssueDetails(error)))
        })
    })
  },

  getAllowedAddressProofsList(loanId) {
    return new Promise(resolve => {
      lenderRepository.getAllowedAddressProofsList(loanId)
        .then(res => {
          resolve(this.onResponse(res.data))
        })
        .catch(error => {
          resolve(this.onError(NetworkErrorUtil.getNetworkIssueDetails(error)))
        })
    })
  },

  getDownpaymentConfiguration(loanId) {
    return new Promise(resolve => {
      PaymentRepository.getDownpaymentConfiguration(loanId)
        .then(res => {
          resolve(this.onResponse(res.data))
        })
        .catch(error => {
          resolve(this.onError(NetworkErrorUtil.getNetworkIssueDetails(error)))
        })
    })
  },

  verifySignature(loanId, orderId, paymentId, signature) {
    return new Promise(resolve => {
      PaymentRepository.verifySignature(loanId, orderId, paymentId, signature)
        .then(res => {
          resolve(this.onResponse(res.data))
        })
        .catch(error => {
          resolve(this.onError(NetworkErrorUtil.getNetworkIssueDetails(error)))
        })
    })
  },

  getPartnerDetailsFromOfficeId(officeId) {
    return new Promise(resolve => {
      CreditEngineOfficeServiceRepository.getPartnerDetailsFromOfficeId(officeId)
        .then(res => {
          resolve(this.onResponse(res.data));
        })
        .catch(error => {
          resolve(this.onError(NetworkErrorUtil.getNetworkIssueDetails(error)));
        })
    })
  },

  getRetailerDetailsFromOfficeId(officeId) {
    return new Promise(resolve => {
      CreditEngineOfficeServiceRepository.getRetailerDetailsFromOfficeId(officeId)
        .then(res => {
          resolve(this.onResponse(res.data));
        })
        .catch(error => {
          resolve(this.onError(NetworkErrorUtil.getNetworkIssueDetails(error)));
        })
    })
  },

  getRetailerConfig(retailerConfigRequest) {
    return new Promise(resolve => {
      PartnerRepository.getRetailerConfig(retailerConfigRequest)
        .then(res => {
          resolve(this.onResponse(res.data))
        })
        .catch(error => {
          resolve(this.onError(NetworkErrorUtil.getNetworkIssueDetails(error)))
        })
    })
  },

  getPublicRetailerConfig(retailerConfigRequest,leadId) {
    return new Promise(resolve => {
      PartnerRepository.getPublicRetailerConfig(retailerConfigRequest,leadId)
        .then(res => {
          resolve(this.onResponse(res.data))
        })
        .catch(error => {
          resolve(this.onError(NetworkErrorUtil.getNetworkIssueDetails(error)))
        })
    })
  },

  getProductCategoriesForOffice(officeId) {
    return new Promise(resolve => {
      ProductRepository.getProductCategoriesForOffice(officeId)
        .then(res => {
          resolve(this.onResponse(res.data))
        })
        .catch(error => {
          resolve(this.onError(NetworkErrorUtil.getNetworkIssueDetails(error)))
        })
    })
  },

  getBrandsForOfficeAndCategory(officeId, category) {
    return new Promise(resolve => {
      ProductRepository.getBrandsForOfficeAndCategory(officeId, category)
        .then(res => {
          resolve(this.onResponse(res.data))
        })
        .catch(error => {
          resolve(this.onError(NetworkErrorUtil.getNetworkIssueDetails(error)))
        })
    })
  },

  getModelsWithDetails(loanId, officeId, category, brand) {
    return new Promise(resolve => {
      ProductRepository.getModelsWithDetails(loanId, officeId, category, brand)
        .then(res => {
          resolve(this.onResponse(res.data))
        })
        .catch(error => {
          resolve(this.onError(NetworkErrorUtil.getNetworkIssueDetails(error)))
        })
    })
  },

  validateProduct(validateProductRequestDto) {
    return new Promise(resolve => {
      ProductRepository.validateProduct(validateProductRequestDto)
        .then(res => {
          resolve(this.onResponse(res.data))
        })
        .catch(error => {
          resolve(this.onError(NetworkErrorUtil.getNetworkIssueDetails(error)))
        })
    })
  },

  sendOTPWithAuth(phoneNumber, smsType, officeId, officeExternalId) {
    return new Promise(resolve => {
      SmsRepository.sendOTPWithAuth(phoneNumber, smsType, officeId, officeExternalId)
        .then(res => {
          resolve(this.onResponse(res.data))
        })
        .catch(error => {
          resolve(this.onError(NetworkErrorUtil.getNetworkIssueDetails(error)))
        })
    })
  },

  generateOTP(phoneNumber) {
    return new Promise(resolve => {
      OTPRepository.generateOTP(phoneNumber)
        .then(res => {
          resolve(this.onResponse(res.data))
        })
        .catch(error => {
          resolve(this.onError(NetworkErrorUtil.getNetworkIssueDetails(error)))
        })
    })
  },

  getOTPVerificationStatus(otpId) {
    return new Promise(resolve => {
      OTPRepository.getOTPVerificationStatus(otpId)
        .then(res => {
          resolve(this.onResponse(res.data))
        })
        .catch(error => {
          resolve(this.onError(NetworkErrorUtil.getNetworkIssueDetails(error)))
        })
    })
  },

  verifyOTP(phoneNumber, otp) {
    return new Promise(resolve => {
      OTPRepository.verify(phoneNumber, otp)
        .then(res => {
          resolve(this.onResponse(res.data))
        })
        .catch(error => {
          resolve(this.onError(NetworkErrorUtil.getNetworkIssueDetails(error)))
        })
    })
  },

  getAddressByAddressId(addressId) {
    return new Promise(resolve => {
      AddressServiceRepository.getAddressByAddressId(addressId)
        .then(res => {
          resolve(this.onResponse(res.data));
        })
        .catch(error => {
          resolve(this.onError(NetworkErrorUtil.getNetworkIssueDetails(error)));
        })
    })
  },

  sendLoanStageDetails(request) {
    return new Promise(resolve => {
      LoanStageRepository.sendLoanStageDetails(request)
        .then(res => {
          resolve(this.onResponse(res.data));
        })
        .catch(error => {
          resolve(this.onError(NetworkErrorUtil.getNetworkIssueDetails(error)));
        })
    })
  },

  getAllOfficeDetails() {
    return new Promise(resolve => {
      OfficeServiceRepository.getAllOffices()
        .then(officesRes => {
          let officeDetails = [];
          const offices = officesRes.data;
          if (offices && offices.length > 0) {
            const noOfOffices = offices.length;
            let officeIndex = 0;
            while (officeIndex++ < noOfOffices) {
              officeDetails.push({});
            }

            let addedOffices = 0;
            offices.forEach((office, officeIndex) => {
              if (EzUtils.isValidId(office.addressId)) {
                this.getAddressByAddressId(office.addressId)
                  .then(addressRes => {
                    if (addressRes.errorOccurred) {
                      resolve(this.onError(addressRes.data));
                    } else {
                      const address = addressRes.data;
                      officeDetails.splice(officeIndex, 1, { office: office, address: address });
                      addedOffices++;
                      if (addedOffices === noOfOffices) {
                        resolve(this.onResponse(officeDetails));
                      }
                    }
                  });
              } else {
                officeDetails.splice(officeIndex, 1, { office: office });
                addedOffices++;
                if (addedOffices === noOfOffices) {
                  resolve(this.onResponse(officeDetails));
                }
              }
            });
          } else {
            resolve(this.onResponse(officeDetails));
          }
        })
        .catch(error => {
          resolve(this.onError(NetworkErrorUtil.getNetworkIssueDetails(error)));
        })
    })
  },

  getIpAddress() {
    return new Promise(resolve => {
      IpFinderRepository.getIpAddress()
        .then(res => {
          resolve(this.onResponse(res.data));
        })
        .catch(error => {
          resolve(this.onError(NetworkErrorUtil.getNetworkIssueDetails(error)));
        })
    })
  },

  getStaffDetails(staffId) {
    return new Promise(resolve => {
      StaffServiceRepository.getStaffDetails(staffId)
        .then(res => {
          resolve(this.onResponse(res.data));
        })
        .catch(error => {
          resolve(this.onError(NetworkErrorUtil.getNetworkIssueDetails(error)));
        })
    })
  },

  getRetailerDetailsFromExternalId(externalId) {
    return new Promise(resolve => {
      CreditEngineOfficeServiceRepository.getRetailerDetailsFromExternalId(externalId)
        .then(res => {
          resolve(this.onResponse(res.data));
        })
        .catch(error => {
          resolve(this.onError(NetworkErrorUtil.getNetworkIssueDetails(error)));
        })
    })
  },
  /**
   * Payload structure
   {
      "clientId" : 3875,
      "identifiers":[
        {
        "identifierType":"PAN_CARD",
        "identifierId":"identifierId"
        }
      ]
    }
   * @param {*} clientId
   * @param {*} identifiersArrayObj
   */
  createClientIdentifierUsingCreditEngine(clientId, identifiersArrayObj) {
    return new Promise(resolve => {
      if (clientId && identifiersArrayObj) {
        let payload = {};
        payload.clientId = clientId;
        payload.identifiers = identifiersArrayObj;

        ClientCreditEngineRepository.createClientIdentifier(payload)
        .then(res => {
          resolve(this.onResponse(res.data));
        })
        .catch(error => {
          resolve(this.onError(NetworkErrorUtil.getNetworkIssueDetails(error)));
        });
      } else {
        resolve(this.onError(NetworkErrorUtil.getErrorObject(
            "Data is not correct", ""
        )));
      }
    });
  },

  getPanOcrData(file) {
    return new Promise(resolve => {
      if (file) {
        panRepository.getPanOcrData(file)
        .then(res => {
          resolve(this.onResponse(res.data));
        })
        .catch(error => {
          resolve(this.onError(NetworkErrorUtil.getNetworkIssueDetails(error)));
        });
      } else {
        resolve(this.onError(NetworkErrorUtil.getErrorObject("Invalid File",
            "File format not supported, Please upload image.")));
      }
    });
  },
  /**
   *
   * @param loanId
   *
   * Response {"isFrontPageRequired" : true/false}
   */
  isFrontPageRequired(loanId) {
    return new Promise(resolve => {
      EzCredServiceRepository.isFrontPageRequired(loanId)
      .then(res => {
        resolve(this.onResponse(res.data));
      })
      .catch(error => {
        resolve(this.onError(NetworkErrorUtil.getNetworkIssueDetails(error)));
      })
    })
  },

  getEmployerList(loanId,querySearch) {
    return new Promise(resolve => {
      lenderRepository.getEmployerList(loanId,querySearch)
        .then(res => {
          resolve(this.onResponse(res.data))
        })
        .catch(error => {
          resolve(this.onError(NetworkErrorUtil.getNetworkIssueDetails(error)))
        })
    })
  },

  processKycVendorCallback(vendor, payload) {
    return new Promise(resolve => {
      vendorKycRepository.processKycVendorCallback(vendor, payload)
      .then(res => {
        resolve(this.onResponse(res.data))
      })
      .catch(error => {
        resolve(this.onError(NetworkErrorUtil.getNetworkIssueDetails(error)));
      })
    })
  },

  /**
   *
   * @param masterValuesRequestDtoMap {"String" : masterDataRequestDto ...}
   * @returns {Promise<{"String" : [] ...}>}
   */

  getMasterValuesForMap(masterValuesRequestDtoMap) {
    return new Promise(resolve => {
      const masterValuesMap = {};
      const masterFields = masterValuesRequestDtoMap
          ? Object.keys(masterValuesRequestDtoMap) : [];
      if (masterFields.length > 0) {
        const noOfMasterFields = masterFields.length;

        let addedMasterValues = 0;
        masterFields.forEach(masterField => {
          this.getMasterValues(masterValuesRequestDtoMap[masterField])
          .then(masterValuesRes => {
            if (masterValuesRes.errorOccurred) {
              resolve(masterValuesRes);
            } else {
              masterValuesMap[masterField] = masterValuesRes.data;
              addedMasterValues++;
              if (addedMasterValues === noOfMasterFields) {
                resolve(this.onResponse(masterValuesMap));
              }
            }
          })
        })
      } else {
        resolve(this.onResponse(masterValuesMap));
      }
    })
  },

  /**
   *
   * @param masterDataRequestDto {"master_name":"columnName", "column_name":"columnName","dependent_value_map":{"key" : "value"...}}
   * @returns {Promise<[...String]>}
   */
  getMasterValues(masterDataRequestDto) {
    return new Promise(resolve => {
      MasterDataRepository.getMasterValues(masterDataRequestDto)
      .then(res => {
        resolve(this.onResponse(res.data));
      })
      .catch(error => {
        resolve(this.onError(NetworkErrorUtil.getNetworkIssueDetails(error)));
      })
    })
  },

  getLenderCoBrandingConfig(lenderName) {
    return new Promise(resolve => {
      lenderRepository.getCoBrandingConfig(lenderName)
        .then(res => {
          resolve(this.onResponse(res.data))
        })
        .catch(error => {
          resolve(this.onError(NetworkErrorUtil.getNetworkIssueDetails(error)))
        })
    })
  },

  notifyDataTableEvent(dataTableName, event, commandProcessingGenericResponse) {
    return new Promise(resolve => {
      HooksRepository.notifyDataTableEvent(
          dataTableName, event, commandProcessingGenericResponse
      )
      .then(res => {
        resolve(this.onResponse(res.data))
      })
      .catch(error => {
        resolve(this.onError(NetworkErrorUtil.getNetworkIssueDetails(error)))
      })
    })
  },

  bulkUploadRows(dataTableBulkUploadRequest) {
    return new Promise(resolve => {
      DataTableCreditEngineRepository.bulkUploadRows(dataTableBulkUploadRequest)
      .then(res => {
        resolve(this.onResponse(res.data));
      })
      .catch(error => {
        resolve(this.onError(NetworkErrorUtil.getNetworkIssueDetails(error)));
      })
    })
  },


  resendBankOtp(loanId) {
    return new Promise(resolve => {
      SmsRepository.resendBankOtp(loanId)
        .then(res => {
          resolve(this.onResponse(res.data))
        })
        .catch(error => {
          resolve(this.onError(NetworkErrorUtil.getNetworkIssueDetails(error)))
        })
    })
  },

  updatePassword(userId, password, repeatPassword) {
    return new Promise(resolve => {
      UserRepository.updatePassword(userId, password, repeatPassword)
      .then(res => {
        resolve(this.onResponse(res.data))
      })
      .catch(error => {
        resolve(this.onError(NetworkErrorUtil.getNetworkIssueDetails(error)))
      })
    })
  },

  getLenderLoanDetailsdFormLenderLoanDetailsResponse(response) {
    if(response && response.data) {
      let lenderLoanDetails = {};
      response.data.forEach(entryObj => {
        for(let key in entryObj) {
          lenderLoanDetails[entryObj.key] = entryObj.value;
        }
      });
      return lenderLoanDetails;
    } else {
      return {};
    }
  },

  onError(err) {
    return this.getResponse(true, err);
  },
  onResponse(data) {
    return this.getResponse(false, data);
  },
  getResponse(errorOccurred, data) {
    return {
      errorOccurred: errorOccurred,
      data: data
    };
  }
};
